import { render, staticRenderFns } from "./orderCardInv.vue?vue&type=template&id=2ac76875&scoped=true&"
import script from "./orderCardInv.vue?vue&type=script&lang=js&"
export * from "./orderCardInv.vue?vue&type=script&lang=js&"
import style0 from "./orderCardInv.vue?vue&type=style&index=0&id=2ac76875&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac76875",
  null
  
)

export default component.exports